import React from 'react';
import { Helmet } from 'react-helmet';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';
import DemoCredentials from './components/DemoCredentials';
import LoginFooter from './components/LoginFooter';

const Login = () => {
  return (
    <>
      <Helmet>
        <title>Login - eCity Pro | Enterprise Project Estimation Platform</title>
        <meta 
          name="description" 
          content="Secure login to eCity Pro - Enterprise-grade project estimation and procurement management platform for telecom and IT projects" 
        />
      </Helmet>

      <div className="min-h-screen bg-background flex items-center justify-center p-4 md:p-6 lg:p-8">
        <div className="w-full max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="lg:pr-8">
                <div className="mb-8 md:mb-10">
                  <h2 className="text-xl md:text-2xl font-bold text-foreground mb-4">
                    Trusted by Industry Leaders
                  </h2>
                  <p className="text-sm md:text-base text-muted-foreground mb-6">
                    Join thousands of professionals managing complex telecom and IT projects with confidence
                  </p>
                </div>
                <TrustSignals />
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto">
                <div className="p-6 md:p-8 lg:p-10 rounded-xl bg-card border border-border shadow-xl">
                  <LoginHeader />
                  <LoginForm />
                  <DemoCredentials />
                </div>
                <LoginFooter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;